import { connect } from 'react-redux';
import { ThunkDispatch } from "redux-thunk";

import { Action, deleteShape, showTextShapeDialog, startSelectorDragging, startShapeDragging } from '../actions';

import {
    State,
    getSelectedShape,
    getShapeDragging,
    XSelector,
    YSelector,
    getSelectorDragging
} from '../reducers';

import ShapeView from '../components/ShapeView';
import { ShapeData, TextShape } from "../services/shape-service";
import * as React from "react";


interface OwnProps {
    readonly slideUuid: string,
    readonly shape: ShapeData,
    readonly calculateSVGPoint: (mouseX: number, mouseY: number) => {x: number, y: number},
}

interface StateProps {
    readonly dragging: boolean,
    readonly resizing: boolean,
    readonly shape: ShapeData,
    readonly selected: boolean,
    readonly stopPropagation: (event: React.MouseEvent<SVGElement>) => void,
}

interface DispatchProps {
    readonly onTextShapeDoubleClicked: (e: React.MouseEvent<SVGElement>) => void,
    readonly onStartDragging: (e: React.MouseEvent<SVGElement>) => void,
    readonly onStartSelectorDragging: (xSelector: XSelector, ySelector: YSelector, e: React.MouseEvent<SVGElement>) => void,
    readonly onDeleteButtonClicked: (e: React.MouseEvent<SVGElement>) => void,
}


function stopPropagation(event: React.MouseEvent<SVGElement>) {
    event.stopPropagation();
    event.preventDefault();
}

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const shapeDragging = getShapeDragging(state);
    const selectorDragging = getSelectorDragging(state);
    return {
        dragging: shapeDragging? shapeDragging.uuid === ownProps.shape.uuid : false,
        resizing: selectorDragging? selectorDragging.shape.uuid === ownProps.shape.uuid : false,
        shape: ownProps.shape,
        selected: getSelectedShape(state) === ownProps.shape.uuid,
        stopPropagation,
    }
};

const mapDispatchToProps = (dispatch: ThunkDispatch<State, any, Action>, ownProps: OwnProps): DispatchProps => (
    {
        onTextShapeDoubleClicked: (e) => {
            stopPropagation(e);
            dispatch(showTextShapeDialog(ownProps.slideUuid, ownProps.shape.uuid, (ownProps.shape as TextShape).text));
        },
        onStartDragging: (e) => {
            stopPropagation(e);
            const {x, y} = ownProps.calculateSVGPoint(e.clientX, e.clientY);
            dispatch(startShapeDragging(ownProps.slideUuid, ownProps.shape.uuid, x, y));
        },
        onStartSelectorDragging: (xSelector, ySelector, e) => {
            stopPropagation(e);
            const {x, y} = ownProps.calculateSVGPoint(e.clientX, e.clientY);
            dispatch(startSelectorDragging(ownProps.slideUuid, ownProps.shape.uuid, xSelector, ySelector, x, y));
        },
        onDeleteButtonClicked: (e) => {
            stopPropagation(e);
            dispatch(deleteShape(ownProps.slideUuid, ownProps.shape.uuid));
        },
    }
);


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShapeView);



// WEBPACK FOOTER //
// ./src/containers/Shape.ts